import { Dialog, DialogContent, DialogActions, Box } from "@mui/material";
import { useState } from "react";
import CustomButton from "../../ui/button/Button";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";

const ClienteContractualModal = ({ open, onConfirm, options }) => {
  const [clienteForm, setClienteForm] = useState(null);

  const handleConfirm = async () => {
    if (!clienteForm) return;

    onConfirm(clienteForm);
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogContent>
        <div>
          <h2>Elige el cliente contractual</h2>
          <Box
            className="stepper-step-content"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
              height: "160px",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <label className="form-label form-label-left">
                Cliente contractual:
              </label>
              <SelectAutoComplete
                options={options}
                fieldC="razonSocial"
                width={"100%"}
                value={clienteForm || {}}
                onChange={(e, value) => setClienteForm(value)}
              />
            </div>
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          className="notifications-button"
          text={"Guardar"}
          color={"#FFFFFF"}
          background={"#223D51"}
          fontStyle={"normal"}
          fontWeight={500}
          fontSize={"14px"}
          height={"40px"}
          type={"button"}
          onClick={handleConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ClienteContractualModal;
